import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IOrder } from './models/orders/order';
import { IVendor } from './models/vendors/vendor';
import { IGst } from './models/gst/gst';

@Injectable({
  providedIn: 'root'
})
export class UiService {

  // Subject to change on login / logout
  loginValid = new Subject<boolean>();
  currentRole = new Subject<string | null | undefined>();

  //class variable so that I can assign perticular order object
  orderObj: IOrder | undefined;

  vendorObj: IVendor | undefined;

  GstObj:IGst | undefined

  //To get if the payment has been accepted
  paymentAccepted = new Subject<boolean>();

  //To take if profile updated for header
  isRefreshHeaderStaffInfo = new Subject<boolean>();

  //To take network status from intercepter
  isOffline = new Subject<boolean>()

  constructor() { }
}
